import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentLoaderService } from 'src/app/core/services/content-loader.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { PolicyService } from 'src/app/core/services/policy.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {
  transactionObject: any;
  messages = [
    "We're crafting your policy. Thanks for waiting!",
    "Your policy is on its way. Hang in there!",
    "Just a moment longer for your custom policy.",
    "We're working on your policy. Almost done!",
    "Thanks for your patience while we generate your policy.",
    "Sit tight! Your policy is being tailored.",
    "Your policy is in progress. Appreciate your patience!",
    "Just a few more seconds for your personalized policy.",
    "Your policy is getting ready. Thanks for waiting!",
    "We're on it! Your policy will be ready soon."
  ];
  currentMessage!: string;
  quotationId: string = '';

  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private restService: RestService,
    private policyService: PolicyService,
    private contentLoaderService: ContentLoaderService,
    private errorHandler: ErrorHandlerService,
    private router: Router) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
    });
    this.route.queryParams.subscribe(params => {
      this.transactionObject = {
        responseStatus: params['responseStatus'],
        transactionStatus: params['transactionStatus'],
        orderReference: params['orderReference'],
        extraData: params['extraData'],
        transactionReference: params['transactionReference'],
        transactionDate: params['transactionDate'],
        transactionAmount: params['transactionAmount'],
        transactionCurrency: params['transactionCurrency'],
        message: params['message']
      };
    });

  }

  ngOnInit(): void {
    if (this.transactionObject?.transactionStatus == 'SUCCESS') {
      this.buyPolicy();
    }

    this.successResponse(this.transactionObject);
  }

  successResponse(transactionObj: any) {
    let params = {
      responseStatus: transactionObj.responseStatus,
      transactionStatus: transactionObj.transactionStatus,
      orderReference: transactionObj.orderReference,
      extraData: transactionObj.extraData,
      transactionReference: transactionObj.transactionReference,
      transactionDate: transactionObj.transactionDate,
      transactionAmount: transactionObj.transactionAmount,
      transactionCurrency: transactionObj.transactionCurrency,
      message: transactionObj.message
    }

    if (this.transactionObject?.transactionStatus == 'FAILED') {
      this.loader.show();
    }

    this.restService.postData(params, 'api/Response/SuccessResponse').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode != 200) {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            if (this.transactionObject?.transactionStatus == 'FAILED') {
              this.loader.hide();
            }
          }
        },
        error: (error: any) => {
          if (this.transactionObject?.transactionStatus == 'FAILED') {
            this.loader.hide();
          }
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  buyPolicy() {
    let params = {
      QuotationID: this.quotationId,
      PaymentMethodID: '5d3154a9-5d2e-4c84-915e-b62b5ea2670a'
    }
    this.contentLoaderService.submitData('api/Quotation/QuotationStatusUpdate', params, this.messages).subscribe(
      {
        next: (data: any) => {
          try {
            if (typeof data === 'string') {
              this.currentMessage = data;
            }
            else if (data.rcode == 200) {
              this.policyService.setPolicyPaymentDetailes(data.rObj.policyNo, data.rObj.ReferenceNumber, false, '');
              this.router.navigate(['policy/policy-purchase-details']);
            }
            else if (data.rcode == 201) {
              this.policyService.setPolicyPaymentDetailes(data.rObj.policyNo, data.rObj.ReferenceNumber, true, data.rObj.ResponseMessage);
              this.router.navigate(['policy/policy-purchase-details']);
            }
            else if (data.rcode != 200 && data.rcode != 201) {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          }
        },
        error: (error) => {
          this.errorHandler.handleStatusError(error);
        }
      }
    );
  }

  routeToHome() {
    this.router.navigate(['/home'])
  }

}
